/* eslint-disable  */
//@ts-nocheck
import React, { ChangeEvent, ChangeEventHandler, useEffect, useRef, useState } from 'react';
import {
  Grid,
  Container,
  InputLabel,
  Box,
  Paper,
  Typography,
  Autocomplete,
  IconButton,
  TextField,
  Button,
  Divider,
  Link,
  FormHelperText,
  MenuItem,
  Select,
} from '@mui/material';
import './ConfigureTile.styles.css';
import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import CloseIcon from '@mui/icons-material/Close';
import NavigationSteps from '../../../../components/NavigationSteps/NavigationSteps.components';
import { useLocation, useNavigate } from 'react-router-dom';
import ReactCrop, { Crop, PixelCrop } from 'react-image-crop';
import { imgPreview } from '../../../../services/image-crop/imagePreview';
import { centerAspectCrop } from '../../../../utils';
import RenderGroutColors from '../../../../services/grout-colors/RenderGroutColors';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { setSelectedTileData } from '../../../../store/tile.slice';
import { title } from 'process';
import ExitWithoutSavingModal from '../../../User/ExitWithoutSaving/ExitWithoutSavingModal.screen';

type TileConfigDataType = {
  shape?: { label: string; aspect: number } | null;
  size?: { label: string; width: number; height: number } | null;
} | null;

type ImageResoultionType = {
  width: number;
  height: number;
} | null;

// Tile shape
const tileshape = [
  { label: 'Square', aspect: 1 },
  { label: 'Rectangle', aspect: 2 },
];
// Tile size
const tileSizeForSquare = [
  { label: '1" x 1"', width: 1, height: 1 },
  { label: '2" x 2"', width: 2, height: 2 },
  { label: '4" x 4"', width: 4, height: 4 },
  { label: '6" x 6"', width: 6, height: 6 },
  { label: '8" x 8"', width: 8, height: 8 },
  { label: '10" x 10"', width: 10, height: 10 },
  { label: '16" x 16"', width: 16, height: 16 },
  { label: '24" x 24"', width: 24, height: 24 },
  { label: '48" x 48"', width: 48, height: 48 },
  { label: 'Custom Dimensions', width: 0, height: 0 },
];

const tileSizeForRectangle = [
  { label: '1" x 2"', height: 1, width: 2 },
  { label: '2" x 4"', height: 2, width: 4 },
  { label: '3" x 6"', height: 3, width: 6 },
  { label: '4" x 8"', height: 4, width: 8 },
  // { label: '6" x 12"', height: 6, width: 12 },
  { label: '12" x 24"', height: 12, width: 24 },
  { label: '12" x 48"', height: 12, width: 48 },
  { label: '6" x 24"', height: 6, width: 24 },
  { label: '8" x 32"', height: 8, width: 32 },
  { label: '8" x 48"', height: 8, width: 48 },
  { label: 'Custom Dimensions', height: 0, width: 0 },
];

enum tileResolution {
  width = 200,
  height = 200,
}

const ConfigureTile = () => {
  const [Open, setOpen] = React.useState(true);
  const imgRef = useRef<HTMLImageElement>(null);

  const { selectedTile, customTile, selectedTileData } = useAppSelector((state) => state.tile);

  const [imgResolution, setImgResolution] = useState<ImageResoultionType>(null);
  const [tileConfigData, setTileConfigData] = useState<TileConfigDataType>(null);
  const [completedCrop, setCompletedCrop] = useState<PixelCrop>();
  const [finalTileImage, setFinalTileImage] = useState('');
  const [error, setError] = useState({});
  const [crop, setCrop] = useState<Crop>();

  useEffect(() => {
    if (selectedTileData) {
      const { tile, shape, size } = selectedTileData;
      if (imgResolution) {
        setCrop(
          centerAspectCrop(
            imgResolution.width,
            imgResolution.height,
            shape.aspect,
            imgResolution.width - imgResolution.width * 0.1,
          ),
        );
      }
      setTileConfigData({ shape, size });
    }
  }, [selectedTileData, imgResolution]);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [imageErr, setImageErr] = useState(false);
  const [navigateTo, setNavigateTo] = useState(false);
  const [openExistModal, setOpenExistModal] = useState(false);

  const handleCloseExistModal = () => {
    setOpenExistModal(false);
  };

  const handleExist = () => {
    navigate('../visualizer/select-tile');
    setOpenExistModal(false);
  };

  const handleBack = () => {
    setOpenExistModal(true);
  };

  function onImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
    const { width, height } = e.currentTarget;
    setImgResolution({ width, height });
  }

  const handleCustomDimension = (event: ChangeEvent<HTMLInputElement>) => {
    const { valueAsNumber, name } = event.target;
    const { shape } = tileConfigData;

    if (tileConfigData && tileConfigData?.shape) {
      if (!valueAsNumber) {
        setError({ ...error, [name]: 'Required' });
      } else if (valueAsNumber < 1) {
        setError({ ...error, [name]: 'Value should be greater or equal to 1' });
      } else if (valueAsNumber > 48) {
        setError({ ...error, [name]: 'Value should be smaller or equal to 48' });
      } else {
        setError({ ...error, [name]: '' });
      }
    }

    setTileConfigData({
      ...tileConfigData,
      size: {
        label: 'Custom Dimensions',
        height: name === 'length' ? valueAsNumber : tileConfigData?.size?.height,
        width:
          shape?.label === 'Square' || name === 'width'
            ? valueAsNumber
            : tileConfigData?.size?.width,
      },
    });
  };

  const handleShape = (e) => {
    const { value } = e.target;
    const data = JSON.parse(value);
    if (imgResolution) {
      setTileConfigData({
        shape: data,
        size: null,
      });
      setCrop(
        centerAspectCrop(
          imgResolution.width,
          imgResolution.height,
          data.aspect,
          imgResolution.width - imgResolution.width * 0.1,
        ),
      );
    }
    setError({});
  };

  const handleSize = (e) => {
    const { value } = e.target;
    setTileConfigData({
      ...tileConfigData,
      size: value,
    });
  };

  useEffect(() => {
    const imagePreviewFn = async () => {
      if (completedCrop?.width && completedCrop?.height && imgRef.current) {
        const cropImage = await imgPreview(imgRef.current, completedCrop, 1, 0, true);
        setFinalTileImage(cropImage);
      }
    };
    imagePreviewFn();
  }, [completedCrop, crop]);

  const handleClick = () => {
    if (tileConfigData && tileConfigData?.size?.width && tileConfigData?.shape) {
      configureCrop.current.props.onChange(crop);
      configureCrop.current.props.onComplete(crop);
      setNavigateTo(true);
    }
  };

  useEffect(() => {
    if (navigateTo && finalTileImage) {
      dispatch(
        setSelectedTileData({
          ...tileConfigData,
          tile: finalTileImage,
        }),
      );
      setNavigateTo(false);
      navigate('./grout-colors');
    }
  }, [navigateTo, finalTileImage]);

  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  const onImageError = () => {
    setImageErr(true);
  };

  const configureCrop = useRef(null);

  const renderTileSizeOpt = () => {
    if (tileConfigData?.shape?.aspect == 1) {
      return tileSizeForSquare.map((item) => (
        <MenuItem key={item.label} value={item}>
          {item.label}
        </MenuItem>
      ));
    } else {
      return tileSizeForRectangle.map((item) => (
        <MenuItem key={item.label} value={item}>
          {item.label}
        </MenuItem>
      ));
    }
  };

  const stepsData = { step: '1', label: 'Configure Tile' };

  const disabledButton =
    !(
      tileConfigData &&
      tileConfigData?.size?.height &&
      tileConfigData?.size?.width &&
      tileConfigData?.shape
    ) || !!(error?.length || error?.width);

  return (
    <Grid container direction="row">
      <Grid size={12}>
        <Grid container direction="row" columnSpacing={4} className="GridRow" paddingBottom={0}>
          <NavigationSteps
            handleClick={handleClick}
            handleBack={handleBack}
            stepsData={stepsData}
            forward={!disabledButton}
          />
        </Grid>
        <Grid container direction="row" columnSpacing={1} className="GridRow LightSkyBlue">
          <Grid size={12}>
            <Box className="CropPhotoCanvas">
              {imageErr || !selectedTile ? (
                <p>Please go back and select tile</p>
              ) : tileConfigData && tileConfigData?.shape ? (
                <ReactCrop
                  ref={configureCrop}
                  aspect={tileConfigData.shape.aspect}
                  crop={crop}
                  locked
                  onChange={(c) => setCrop(c)}
                  onComplete={(img: PixelCrop) => {
                    setCompletedCrop(img);
                  }}
                >
                  {selectedTile && (
                    <img
                      ref={imgRef}
                      src={selectedTile}
                      alt=""
                      onLoad={onImageLoad}
                      onError={onImageError}
                      style={{ width: 300, height: 300 }}
                    />
                  )}
                </ReactCrop>
              ) : (
                selectedTile && (
                  <img
                    ref={imgRef}
                    src={selectedTile}
                    alt=""
                    onLoad={onImageLoad}
                    onError={onImageError}
                    style={{ width: 300, height: 300 }}
                  />
                )
              )}
            </Box>
            {/* <img src={finalTileImage} alt="" /> */}
          </Grid>
        </Grid>
        <Grid container direction="row" columnSpacing={1} className="GridRow">
          <Grid size={12}>
            <Container maxWidth="sm" disableGutters>
              <Grid container direction="row" columnSpacing={0} className="DefaultTileContainer">
                <Grid size={12}>
                  <Box className="CommonFormControl">
                    <InputLabel>Tile Shape</InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={JSON.stringify(tileConfigData?.shape) || ''}
                      onChange={handleShape}
                      label="Tile Shape"
                    >
                      {tileshape.map((item) => (
                        <MenuItem key={item.label} value={JSON.stringify(item)}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </Box>
                  <Box className="CommonFormControl">
                    <InputLabel>Tile Size (inches)</InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={tileConfigData?.size || {}}
                      onChange={handleSize}
                      label="Tile Size"
                      disabled={!tileConfigData?.shape}
                      renderValue={(v) => v.label}
                    >
                      {renderTileSizeOpt()}
                    </Select>
                  </Box>
                </Grid>
                {tileConfigData && tileConfigData?.size?.label === 'Custom Dimensions' && (
                  <>
                    <Grid size={5} className="PositionRelative">
                      <Box className="" sx={{ mt: 3 }}>
                        <InputLabel>Length (inches)</InputLabel>
                        <TextField
                          name="length"
                          type="number"
                          label=""
                          defaultValue={tileConfigData?.size?.height || 0}
                          InputProps={{
                            inputProps: {
                              min: 0,
                            },
                          }}
                          onKeyPress={(event) => {
                            if (!/[0-9]/.test(event.key)) {
                              event.preventDefault();
                            }
                          }}
                          onChange={handleCustomDimension}
                          variant="outlined"
                        />
                      </Box>
                      <FormHelperText className="FloatError">{error?.length}</FormHelperText>
                    </Grid>
                    <Grid size={2} className="Relative">
                      <Box className="MultipleIcon">x</Box>
                    </Grid>
                    <Grid size={5} className="PositionRelative">
                      {tileConfigData?.shape?.label === 'Rectangle' ? (
                        <Box className="" sx={{ mt: 3 }}>
                          <InputLabel>Width (inches)</InputLabel>
                          <TextField
                            name="width"
                            type="number"
                            label=""
                            defaultValue={tileConfigData?.size?.width || 0}
                            InputProps={{
                              inputProps: {
                                min: 0,
                              },
                            }}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            onChange={handleCustomDimension}
                            variant="outlined"
                            className="CustomDisabled"
                          />
                        </Box>
                      ) : (
                        <Box className="" sx={{ mt: 3 }}>
                          <InputLabel>Width (inches)</InputLabel>
                          <TextField
                            name="width"
                            type="number"
                            label=""
                            value={tileConfigData?.size?.width || 0}
                            variant="outlined"
                            disabled
                            className="CustomDisabled"
                          />
                        </Box>
                      )}
                      <FormHelperText className="FloatError">{error?.width}</FormHelperText>
                    </Grid>
                  </>
                )}
              </Grid>
              <Grid size={12} className="BottomNextButton">
                <Button
                  variant="contained"
                  color="primary"
                  endIcon={<KeyboardArrowRightOutlinedIcon />}
                  onClick={handleClick}
                  disabled={disabledButton}
                >
                  Next
                </Button>
              </Grid>
            </Container>
          </Grid>
        </Grid>
      </Grid>
      <ExitWithoutSavingModal
        open={openExistModal}
        handleClose={handleCloseExistModal}
        onExist={handleExist}
      />
    </Grid>
  );
};

export default ConfigureTile;
